import { api } from "../../helpers/api/handler"

export const resubscribe = () => api.get("/auth/resubscribe")
